// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1w-sL","header":"PatientBlock_header__1nLWZ","label":"PatientBlock_label__1Ayck","option":"PatientBlock_option__3KCI7"};